import { TabPanel } from '@microsoft/fast-foundation';
import { ChameleonElementMixin } from '../../common/mixin';
export class TabPanelComponent extends ChameleonElementMixin(TabPanel) {
}
